import { z } from "zod";
import { TObjectBase, TFile } from "../base";
import { TFirebaseTimestamp } from "../deprecated";
import { TTranslationData } from "../common/translation";
import { TReadAccess } from "../common/readAccess";

const idSchema = z.string();
const TUserIDsSchema = z.array(idSchema);
const TCompaniesIDsSchema = z.array(idSchema);
export const TNotificationPlatformSchema = z.object({
  platforms: z.object({
    mobile: z.boolean().optional(),
    email: z.boolean().optional(),
    sms: z.boolean().optional(),
    mobileReceivers: z.array(z.string()).optional(),
    emailReceivers: z.array(z.string()).optional(),
    smsReceivers: z.array(z.string()).optional(),
    tenantEmailReceiverSettings: z
      .object({
        contactEmail: z.boolean(),
        members: z.boolean(),
      })
      .optional(),
    tenantMessageReceiverSettings: z
      .object({
        contactNumber: z.boolean(),
        members: z.boolean(),
      })
      .optional(),
  }),
});
export type IRawNotificationPlatform = z.infer<
  typeof TNotificationPlatformSchema
>;

export const TRawPost = z
  .object({
    author: z
      .object({ users: TUserIDsSchema, companies: TCompaniesIDsSchema })
      .optional(),
    body: TTranslationData,
    title: TTranslationData,
    files: z.record(TFile).optional(),
    description: z.string().optional(),
    id: z.string(),
    readAccess: TReadAccess.optional(),
    postDate: TFirebaseTimestamp.optional(),
    notificationSettings: z
      .object({ onCreate: TNotificationPlatformSchema })
      .optional(),
  })
  .extend(TObjectBase.shape);
export type IRawPost = z.infer<typeof TRawPost>;
